module.exports = __webpack_public_path__ + "img/probiotic-2.9a3057f6.png";